export const LEPRECHAUNS_ADDITIONAL_BASIC_INCOME = 1;
export const LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT = 5;
